module.exports = __webpack_public_path__ + "img/mars.cda370d9.svg";